var map = {
	"./dreamroom.jpg": 32,
	"./florida.jpg": 33,
	"./furniture.png": 34,
	"./hallowkitty.jpg": 35,
	"./musicapp.png": 36,
	"./orca.jpg": 37,
	"./rzd.jpg": 38,
	"./wobbly.jpg": 39,
	"./woodworking.png": 40
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31;